import axios, { AxiosError } from "axios";
import { useMutation, useQuery, UseQueryResult } from "react-query";
import ReconFile, { ReconFilesListResponse } from "../model/ReconFile";

export const GetReconFileApiService = async (request: any): Promise<any> => {
    const url = `/calendar_events/recon_file`;
    const { data } = await axios.get(`${url}?employerId=${request.employerId}&reconFile=${request.reconFile}`);
    
    return data;
};

export const GetReconFilesListApiService = async (request: {
    employerId: string;
    date: string;
}): Promise<ReconFilesListResponse> => {
    const url = `/calendar_events/recon_files`;
    const { data } = await axios.get(url, {
        params: {
            employerId: request.employerId,
            date: request.date,
        },
    });
    
    return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useGetReconFileApiService = () =>
    useMutation<ReconFile, AxiosError, any>(
        "GetReconFileApiService", 
        GetReconFileApiService
    );

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useGetReconFilesListApiService = ({
    employerId,
    date,
    enabled,
}: {
    employerId?: string;
    date?: string;
    enabled?: boolean;
}): UseQueryResult<ReconFilesListResponse, AxiosError> =>
    useQuery<ReconFilesListResponse, AxiosError>(
        ["GetReconFilesListApiService", employerId, date],
        () => {
            if (!employerId || !date) {
                throw new Error("Missing employerId or date");
            }
            return GetReconFilesListApiService({ employerId, date });
        },
        {
            enabled: Boolean(enabled && employerId && date),
            keepPreviousData: true,
            staleTime: 30000, // Cache for 30 seconds
        }
    );

export default useGetReconFileApiService;
